// src/pages/Home.js
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Home.css';
import Navbar from '../components/Navbar';
/*import PhotoGallery from '../components/PhotoGallery';
import CaseStudies from '../components/CaseStudies';*/
import CtaBanner from '../components/CtaBanner';
import Solutions from '../components/Solutions';
import CtaSection from '../components/CtaSection';
import Testimonials from '../components/Testimonials';
import homeSolutionsData from '../components/homeSolutionsData';
import imageUrl from '../assets/header-image.jpg';



const Home = () => {
  return (
    <div>
      <Helmet>
        <title>Doclivo - Revolutionize Your Practice with Next-Generation Healthcare Software</title>
        <meta name="description" content="This is the home page of Your Company Name, offering top-notch solutions to help you automate, optimize, and grow your business." />
        <meta name="keywords" content="healthcare solutions, automation, optimization" />
      </Helmet>

      <Navbar></Navbar>

      <Header
        title="The complete EMR platform for your practice"
        subtitle="A platform that provides a complete and intuitive technology stack from independent doctors to multi-speciality hospitals. An easy to use solution that eliminates the need of physical managing multiple applications or interfaces with varying capabilities across different platforms."
        imageUrl={imageUrl}
        buttonText="Get Demo"
        secondaryButtonText="Why Doclivo"
        showSecondaryButton={true} // Show both buttons
      >
      </Header>

      <main>
        <div className="home">
          <CtaBanner></CtaBanner>
          <Solutions
            solutionsData={homeSolutionsData}
            sectionTitle="Tomorrow’s solutions for today’s provider"
            sectionSubtitle="Solutions"
          >
          </Solutions>

          {/*  <PhotoGallery></PhotoGallery>
          <CaseStudies></CaseStudies> */}
          {/* <Testimonials></Testimonials> */}
          <CtaSection></CtaSection>

        </div>
      </main>
      <Footer />
    </div >
  );
};

export default Home;